import { Box, Button, Drawer, FormLabel, IconButton, Input, Modal, Tooltip } from "@mui/material";
import { FunctionComponent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import AssignmentIndRoundedIcon from '@mui/icons-material/AssignmentIndRounded';
import styled from "styled-components";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ContentPasteRoundedIcon from '@mui/icons-material/ContentPasteRounded';
import { useErrorSuccess } from "../../../../../hooks/useErrorSuccess";
import ServicesLideres from "../services/servicesGetLideres";

interface ListaMembrosProps {

}

type Lider = {
  cargo: string,
  celula: string,
  cpf: string,
  email: string,
  nome: string,
  telefone: string,
  usuario: number,
}

const ListaMembrosPg: FunctionComponent<ListaMembrosProps> = () => {

  const nav = useNavigate();

  const { setErrorSuccess } = useErrorSuccess();

  const { lideres, removeLideres } = ServicesLideres()

  const [open, setOpen] = useState<boolean>(false);

  const [openModalContact, setOpenModalContact] = useState<boolean>(false);

  const [lider, setLider] = useState<Lider>();

  const onClose = () => {
    setOpen(false);
    setTimeout(() => {
      nav(-1);
    }, 200)
  };

  const onOpen = () => {
    setOpen(true)
  }

  useEffect(() => {
    onOpen()
  }, [])


  const onCloseModalContact = () => {
    setOpenModalContact(false);
  }

  const onOpenModalContact = (lider: Lider) => {
    setOpenModalContact(true);
    setLider(lider)
  }

  const copy = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      return setErrorSuccess({
        mensagem: 'Copiado!',
        status: 'success'
      })
    } catch (error) {
      return setErrorSuccess({
        mensagem: JSON.stringify(error.response.data, null, 2),
        status: 'error'
      })
    }
  }


  return (<>
    <Modal
      open={openModalContact}
      onClose={onCloseModalContact}
    >
      <Box sx={{
        p: 2,
        backgroundColor: '#fff',
        position: 'absolute',
        top: '45%',
        left: '40%',
        display: 'flex',
        borderRadius: '8px',
        flexDirection: 'column'
      }}>
        <Input
          value={
            lider?.telefone
          }
          contentEditable={false}
          endAdornment={
            <Tooltip title="Copiar">
              <IconButton onClick={() => copy(lider?.telefone)}>
                <ContentPasteRoundedIcon />
              </IconButton>
            </Tooltip>
          }
          disableUnderline
        />
        <Input
          value={
            lider?.email
          }
          contentEditable={false}
          endAdornment={
            <Tooltip title="Copiar">
              <IconButton onClick={() => copy(lider?.email)}>
                <ContentPasteRoundedIcon />
              </IconButton>
            </Tooltip>
          }
          disableUnderline
        />
      </Box>
    </Modal>
    <Drawer
      open={open}
      onClose={onClose}
      anchor="right"
    >
      <Box
        sx={{
          padding: 2,
          background: '#fff'
        }}

      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '4px' }}>
          <Box
          onClick={onClose}
          sx={{
            border: '1px solid #ccc',
            display: 'flex',
            cursor: 'pointer',
            alignItems: 'center',
            borderRadius: '4px',
            ":hover": { boxShadow: '2px 3px 3px rgba(0,0,0,.2)' }
            }}>
            <CloseRoundedIcon />
          </Box>
          <h2>
            Líderes
          </h2>
        </div>
        <Button variant="contained" sx={{ boxShadow: 'none', my: 1 }} onClick={() => nav('add/coordenadores')}>
          Adicionar
        </Button>
        {
          lideres?.map(
            usuario => (
              <BoxLider>
                <FormLabel sx={{ display: 'flex', alignItems: 'end' }}>
                  <PersonRoundedIcon />
                  {usuario?.nome}
                </FormLabel>
                <FormLabel sx={{ display: 'flex', alignItems: 'end' }}>
                  <AssignmentIndRoundedIcon />
                  {usuario?.cargo}
                </FormLabel>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Button color="error" onClick={() => removeLideres(usuario)}>Remove</Button>
                  <Button color="info" onClick={() => onOpenModalContact(usuario)}>Contacto</Button>
                </div>
              </BoxLider>
            )
          )
        }

      </Box>
    </Drawer>
  </>);
}

const BoxLider = styled.div`
  border: 1px solid #ccc;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 8px;
  padding: 4px;
  margin-bottom: 8px;
  transition: 250ms ease-in all;

  &:hover {
    cursor: pointer;
    box-shadow: 2px 3px 3px rgba(0,0,0,.2);
  }

  & > label {
    pointer-events: none;
  }

`

export default ListaMembrosPg;




// const MockData: Lider[] = [
//   {
//     cargo: "Coordenador",
//     celula: "319",
//     cpf: "06464202405",
//     email: "matheustelles@gmail.com",
//     nome: "Diane Rodrigues Pimentel Mesquita ",
//     telefone: "83988987587",
//     usuario: 1368,
//   },
//   {
//     cargo: "Supervisor",
//     celula: "319",
//     cpf: "06464202405",
//     email: "tiago.ary@gmail.com",
//     nome: "Diane Rodrigues Pimentel Mesquita ",
//     telefone: "83988987587",
//     usuario: 1367,
//   },
//   {
//     cargo: "Coordenador",
//     celula: "319",
//     cpf: "06464202405",
//     email: "eryckavel@gmail.com",
//     nome: "Diane Rodrigues Pimentel Mesquita ",
//     telefone: "83988987587",
//     usuario: 1366,
//   },
//   {
//     cargo: "Supervisor",
//     celula: "319",
//     cpf: "06464202405",
//     email: "diane170689@gmail.com",
//     nome: "Diane Rodrigues Pimentel Mesquita ",
//     telefone: "83988987587",
//     usuario: 1365,
//   }
// ]
